<template>
    <vx-card id="loader">
        <div class="vx-row header-title ml-3">
            <h3>Аудитории ремаркетинга</h3>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/3">
                <label class="vs-input--label"> Пользователи </label>
                <v-select
                    multiple
                    label="email"
                    :options="dicts.users"
                    placeholder="Выберите пользователей"
                    class="w-full"
                    v-bind:class="{ 'select-error': !!errors.users }"
                    v-model="form.users"
                    :reduce="(u) => u.id"
                >
                </v-select>
            </div>

            <div class="vx-col w-1/3">
                <label class="vs-input--label"> Кампании белый список </label>
                <v-select
                    multiple
                    clearable
                    :options="dicts.campaignWhitelist"
                    label="name"
                    placeholder="Выберите кампании"
                    class="w-full"
                    v-bind:class="{ 'select-error': !!errors.campaignsWhitelist }"
                    v-model="form.campaignsWhitelist"
                    :reduce="(b) => b.id"
                >
                </v-select>
            </div>

            <div class="vx-col w-1/3">
                <label class="vs-input--label"> Кампании черный список </label>
                <v-select
                    multiple
                    clearable
                    :options="dicts.campaignBlacklist"
                    label="name"
                    placeholder="Выберите кампании"
                    class="w-full"
                    v-bind:class="{ 'select-error': !!errors.campaignsBlacklist }"
                    v-model="form.campaignsBlacklist"
                    :reduce="(b) => b.id"
                >
                </v-select>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="form.searchPattern"
                        autocomplete="off"
                        v-on:keyup.enter="loadAuditories()"
                        label="По названию"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-1/4">
                <div class="mt-1">
                    <label class="vs-input--label"> Дата </label>
                    <date-picker
                        :not-before="disabledBefore"
                        :not-after="disabledAfter"
                        range
                        v-model="dateInterval"
                        value-type="format"
                        format="YYYY-MM-DD"
                        placeholder="Выберите дату"
                        :lang="'ru'"
                        :firstDayOfWeek="1"
                        class="date-p w-full"
                    >
                    </date-picker>
                </div>
            </div>

            <div class="vx-col w-1/4 mb-1">
                <div class="mt-1">
                    <vs-button class="mt-6" color="success" @click="loadAuditories(true)" type="filled"> Получить </vs-button>
                </div>
            </div>
        </div>
        <vs-button class="mt-2 float-left" color="success" @click="showCreateModal(tr)" type="filled"> Создать аудиторию </vs-button>

        <vs-table stripe :data="auditories" search max-items="10" class="mt-5">
            <template slot="thead">
                <vs-th> Id </vs-th>
                <vs-th class="vs-lg-4"> Название </vs-th>
                <vs-th></vs-th>
                <vs-th> Дата создания </vs-th>
                <vs-th> Длительность, дней </vs-th>
                <vs-th> Кампании вкл. </vs-th>
                <vs-th> Кампании искл. </vs-th>
                <vs-th> Базовая кампания </vs-th>
                <vs-th> Емкость </vs-th>
                <vs-th> Тип </vs-th>
                <vs-th> События </vs-th>
                <vs-th> Статус </vs-th>
                <vs-th> Обновлен </vs-th>
                <vs-th title="Cколько было кликов/конверсий по аудитории за последний день"> Действий вчера </vs-th>
                <vs-th title="Сколько уникальных пользователей совершали действия"> Уник. юзеров вчера </vs-th>
                <vs-th> Емкость вчера </vs-th>
                <vs-th> Прирост юзеров вчера </vs-th>
                <vs-th> Удалено по TTL юзеров вчера </vs-th>
                <vs-th> </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.id }}</vs-td>
                    <vs-td>{{ tr.name }}</vs-td>
                    <vs-td
                        ><div class="inline-block cursor-pointer">
                            <vx-tooltip text="Изменить аудиторию" position="top" delay=".3s">
                                <feather-icon @click="showEditModal(tr)" icon="Edit2Icon" class="inline-block mr-2" svgClasses="w-6 h-6" />
                            </vx-tooltip></div
                    ></vs-td>
                    <vs-td>{{ tr.createdAt | moment('DD.MM.YYYY HH:mm') }}</vs-td>
                    <vs-td>{{ tr.ttl }}</vs-td>
                    <vs-td>{{ tr.campaignsWhitelist ? tr.campaignsWhitelist.join(', ') : '' }}</vs-td>
                    <vs-td>{{ tr.campaignsBlacklist ? tr.campaignsBlacklist.join(', ') : '' }}</vs-td>
                    <vs-td>
                        <router-link :to="{ name: 'campaign-edit', params: { id: tr.campaignBase } }">
                            {{ tr.campaignBase }}
                        </router-link>
                    </vs-td>
                    <vs-td>{{ tr.usersCount }}</vs-td>
                    <vs-td>{{ getTypeName(tr.type) }}</vs-td>
                    <vs-td>{{ getGoalName(tr.goalIds) }}</vs-td>
                    <vs-td>{{ tr.status }}</vs-td>
                    <vs-td>{{ tr.usersUpdatedAt | moment('DD.MM.YYYY HH:mm') }}</vs-td>
                    <vs-td>{{ tr.actionsCountYesterday }}</vs-td>
                    <vs-td>{{ tr.usersUniqCountYesterday }}</vs-td>
                    <vs-td>{{ tr.usersCountYesterday }}</vs-td>
                    <vs-td>{{ tr.usersAddedYesterday }}</vs-td>
                    <vs-td>{{ tr.usersRemovedByTtlYesterday }}</vs-td>
                    <vs-td>
                        <div class="inline-block cursor-pointer">
                            <vx-tooltip text="Удалить аудиторию" position="top" delay=".3s">
                                <feather-icon
                                    @click="showDeleteModal(tr)"
                                    icon="XCircleIcon"
                                    class="inline-block mr-2 text-danger"
                                    svgClasses="w-7 h-7"
                                />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <sweet-modal blocking ref="createModal" class="auditory-create" title="Новая аудитория">
            <div class="vx-row">
                <div class="vx-col w-5/6">
                    <vs-input
                        v-model="form.name"
                        :danger="!!errors.name"
                        :danger-text="errors.name"
                        autocomplete="off"
                        label="Название аудитории"
                        class="w-full required"
                    />
                </div>

                <div class="vx-col w-1/6">
                    <vs-input
                        type="number"
                        v-model="form.ttl"
                        :danger="!!errors.ttl"
                        :danger-text="errors.ttl"
                        autocomplete="off"
                        label="дней"
                        class="w-full required"
                    />
                </div>
            </div>
            <div class="mb-5">
                <label class="vs-input--label required"> Тип аудитории </label>
                <v-select
                    :clearable="false"
                    :options="dicts.types"
                    label="name"
                    placeholder="Выберите тип аудитории"
                    сlass="mt-1 w-1/2"
                    v-model="form.type"
                    :reduce="(s) => s.id"
                >
                </v-select>
            </div>
            <div v-if="form.type == 2" class="mb-5">
                <label class="vs-input--label required"> События </label>
                <v-select
                    :clearable="false"
                    multiple
                    :options="dicts.goals"
                    label="name"
                    placeholder="Выберите события"
                    сlass="events-select mt-1 w-1/2"
                    v-model="form.goals"
                    :reduce="(s) => s.id"
                >
                </v-select>
            </div>
            <vs-button color="success" @click="saveAuditory()" type="filled"> Создать аудиторию </vs-button>
        </sweet-modal>
        <sweet-modal blocking ref="editModal" class="auditory-edit" title="Редактировать аудиторию">
            <div class="vx-row">
                <div class="vx-col w-5/6">
                    <vs-input
                        v-model="form.name"
                        :danger="!!errors.name"
                        :danger-text="errors.name"
                        autocomplete="off"
                        label="Название аудитории"
                        class="w-full required"
                    />
                </div>

                <div class="vx-col w-1/6">
                    <vs-input
                        type="number"
                        v-model="form.ttl"
                        :danger="!!errors.ttl"
                        :danger-text="errors.ttl"
                        autocomplete="off"
                        label="дней"
                        class="w-full required"
                    />
                </div>
            </div>
            <label class="vs-input--label required"> Тип аудитории </label>
            <v-select
                disabled
                :clearable="false"
                :options="dicts.types"
                label="name"
                placeholder="Выберите тип аудитории"
                сlass="mt-1 w-1/2"
                v-model="form.type"
                :reduce="(s) => s.id"
            >
            </v-select>

            <div class="mb-5">
                <vs-input
                    type="text"
                    v-model="form.campaignsTargetingWhitelist"
                    :danger="!!errors.campaignsTargetingWhitelist"
                    :danger-text="errors.campaignsTargetingWhitelist"
                    :disabled="this.isEditTargetingDisabled()"
                    autocomplete="off"
                    label="Белый список таргетинга кампаний, id через запятую"
                    class="mt-1 w-full"
                />
            </div>
            <div class="mb-5">
                <vs-input
                    type="text"
                    v-model="form.campaignsTargetingBlacklist"
                    :danger="!!errors.campaignsTargetingBlacklist"
                    :danger-text="errors.campaignsTargetingBlacklist"
                    :disabled="this.isEditTargetingDisabled()"
                    autocomplete="off"
                    label="Черный список таргетинга кампаний, id через запятую"
                    class="mt-1 w-full"
                />
            </div>

            <div v-if="form.type == 2" class="mb-5">
                <label class="vs-input--label required"> События </label>
                <v-select
                    :clearable="false"
                    multiple
                    :options="dicts.goals"
                    label="name"
                    placeholder="Выберите события"
                    сlass="mt-1 w-1/2"
                    v-model="form.goals"
                    :reduce="(s) => s.id"
                >
                </v-select>
            </div>

            <vs-button class="" color="success" @click="updateAuditory()" type="filled"> Сохранить аудиторию </vs-button>
        </sweet-modal>
        <sweet-modal ref="deleteModal" icon="error" title="Удаление аудитории">
            <div class="mb-5">Вы действительно хотите удалить аудиторию '{{ selected.name }}'? Она будет удалена из всех связанных кампаний.</div>

            <vs-button class="" color="danger" @click="deleteAuditory(selected)" type="filled"> Удалить аудиторию </vs-button>
        </sweet-modal>
        <vs-pagination :max="5" :total="pagesTotal" v-model="page"></vs-pagination>
    </vx-card>
</template>


<script>
import axios from 'axios';
import qs from 'qs';
import DatePicker from 'vue2-datepicker';
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';
import vSelect from 'vue-select';
const startPeriod = new Date(2023, 11, 20); // Дата начала сбора аудиторий
const endPeriod = new Date(); // Максимальный период до сегодня
const targetingMinimalUsersCount = 1000; // Минимальное количество пользователей для возможности таргетинга
const defaultTTL = 90; // Минимальное количество пользователей для возможности таргетинга

export default {
    name: 'auditoriesRemarketing',
    data() {
        return {
            auditories: [],
            selected: {},

            page: 1,
            pageSize: 25,
            pagesTotal: 1,

            disabledBefore: startPeriod,
            disabledAfter: endPeriod,
            dateInterval: undefined,

            dicts: {
                types: [
                    { id: 1, name: 'Clicks' },
                    { id: 2, name: 'Actions' }
                ],
                pageSizes: [25, 50, 100, 500],
                campaignWhitelist: [],
                campaignBlacklist: [],
                users: [],
                goals: []
            },

            form: {
                name: undefined,
                type: undefined,
                ttl: defaultTTL,
                campaignsTargetingWhitelist: undefined,
                campaignsTargetingBlacklist: undefined,

                searchPattern: undefined,
                users: undefined,
                campaignsWhitelist: undefined,
                campaignsBlacklist: undefined,
                date_time_from: undefined,
                date_time_to: undefined,
                goals: undefined
            },
            errors: {
                name: '',
                ttl: ''
            }
        };
    },
    components: {
        SweetModal,
        SweetModalTab,
        vSelect,
        'date-picker': DatePicker
    },
    methods: {
        loadDicts() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            this.axios
                .all([this.axios.get('auditoriesRemarketing/dicts')])
                .then(
                    axios.spread((dicts) => {
                        Object.entries(dicts.data.users).forEach((entry) => {
                            const [key, value] = entry;
                            this.dicts.users.push({
                                id: key,
                                email: value
                            });
                        });

                        Object.entries(dicts.data.campaignWhitelist).forEach((entry) => {
                            const [key, value] = entry;
                            this.dicts.campaignWhitelist.push({
                                id: key,
                                name: value
                            });
                        });

                        Object.entries(dicts.data.campaignBlacklist).forEach((entry) => {
                            const [key, value] = entry;
                            this.dicts.campaignBlacklist.push({
                                id: key,
                                name: value
                            });
                        });

                        this.dicts.goals = dicts.data.goals;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки справочников.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });;
        },
        loadAuditories(disableLoader) {
            if (!disableLoader) {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });
            }

            console.log(this.form.users);
            console.log(this.form.campaignsWhitelist);
            console.log(this.form.campaignsBlacklist);
            const params = {
                searchPattern: this.form.searchPattern ? this.form.searchPattern.trim() : undefined,
                userIds: this.form.users,
                campaignsWhitelistIds: this.form.campaignsWhitelist ? this.form.campaignsWhitelist.map((c) => c) : undefined,
                campaignsBlacklistIds: this.form.campaignsBlacklist ? this.form.campaignsBlacklist.map((c) => c) : undefined,
                startPeriod: this.form.date_time_from,
                endPeriod: this.form.date_time_to,
                page: this.page,
                size: this.pageSize
            };
            console.log(params);

            this.axios
                .all([
                    this.axios.get('auditoriesRemarketing', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { arrayFormat: 'repeat' });
                        }
                    })
                ])
                .then(
                    axios.spread((auditories) => {
                        console.log(auditories);
                        this.auditories = auditories.data.items;
                        this.pagesTotal = auditories.data.pagesTotal;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки аудиторий ремаркетинга.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    if (!disableLoader) {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                    }
                });
        },
        validateFields() {
            if (!this.form.name) {
                return 'Введите название аудитории';
            }

            if (this.form.ttl < 1) {
                return 'Продолжительность должна быть больше нуля';
            }

            if (!this.form.type) {
                return 'Выберите тип аудитории';
            }

            if (this.form.type == 2 && (!this.form.goals || this.form.goals.length == 0)) {
                return 'Выберите события';
            }
        },
        changePageSize() {
            this.page = 1;
            this.loadAuditories();
        },
        showCreateModal() {
            this.form.name = undefined;
            this.form.type = undefined;
            this.form.ttl = defaultTTL;
            this.form.goals = undefined;
            this.$refs.createModal.open();
        },
        saveAuditory() {
            var errorFields = this.validateFields();
            if (errorFields) {
                return this.$vs.notify({
                    title: 'Внимание!',
                    text: errorFields,
                    color: 'warning'
                });
            }

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            const params = {
                name: this.form.name,
                ttl: this.form.ttl,
                type: this.form.type,
                goalIds: this.form.goals
            };
            this.$axios({
                method: 'POST',
                url: 'auditoriesRemarketing',
                params: params,
                errors: this.errors,
                success: () => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно добавлено',
                        text: 'Аудитория успешно добавлена',
                        color: 'success'
                    });
                    this.loadAuditories();
                    this.$refs.createModal.close();
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Ошибка при добавлении аудитории!',
                        text: err.response.data,
                        color: 'danger'
                    });
                }
            });
        },
        showEditModal(selected) {
            this.selected = selected;
            this.form.name = selected.name;
            this.form.type = selected.type;
            this.form.ttl = selected.ttl;
            this.form.goals = selected.goalIds;
            this.form.campaignsTargetingWhitelist = selected.campaignsWhitelist.join(', ');
            this.form.campaignsTargetingBlacklist = selected.campaignsBlacklist.join(', ');

            if (this.selected.usersCount < targetingMinimalUsersCount) {
                let message = `Емкость аудитории меньше ${targetingMinimalUsersCount} человек`;
                this.form.campaignsTargetingWhitelist = message;
                this.form.campaignsTargetingBlacklist = message;
            }

            this.$refs.editModal.open();
        },
        updateAuditory() {
            var errorFields = this.validateFields();
            if (errorFields) {
                return this.$vs.notify({
                    title: 'Внимание!',
                    text: errorFields,
                    color: 'danger'
                });
            }

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            console.log(this.form.campaignsTargetingWhitelist);
            console.log(this.form.campaignsTargetingBlacklist);
            const params = {
                id: this.selected.id,
                name: this.form.name,
                ttl: this.form.ttl,
                type: this.form.type,
                goalIds: this.form.goals,
                campaignsWhitelist:
                    this.form.campaignsTargetingWhitelist && !this.isEditTargetingDisabled()
                        ? this.form.campaignsTargetingWhitelist.split(',').map((item) => item.trim())
                        : undefined,
                campaignsBlacklist:
                    this.form.campaignsTargetingBlacklist && !this.isEditTargetingDisabled()
                        ? this.form.campaignsTargetingBlacklist.split(',').map((item) => item.trim())
                        : undefined
            };
            this.$axios({
                method: 'PUT',
                url: 'auditoriesRemarketing/' + this.selected.id,
                params: params,
                errors: this.errors,
                success: () => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Аудитория успешно обновлена',
                        color: 'success'
                    });
                    this.loadAuditories();
                    this.$refs.editModal.close();
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Ошибка при сохранении аудитории!',
                        text: err.response.data,
                        color: 'danger'
                    });
                }
            });
        },
        showDeleteModal(auditory) {
            this.selected = auditory;
            this.$refs.deleteModal.open();
        },
        deleteAuditory(auditory) {
            this.$axios({
                method: 'DELETE',
                url: 'auditoriesRemarketing/' + auditory.id,
                errors: this.errors,
                success: () => {
                    this.auditories = this.auditories.filter((c) => c.id != auditory.id);
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно удалено',
                        text: 'Аудитория успешно удалена.',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при удалении аудитории!',
                        color: 'danger'
                    });
                }
            });
        },
        setDefaultValues() {
            let d = new Date();
            let today = this.$moment(d).format('YYYY-MM-DD');
            let startAt = this.$moment(startPeriod).format('YYYY-MM-DD');
            this.dateInterval = [startAt, today];
            this.form.date_time_from = this.$moment(this.dateInterval[0]).format('YYYY-MM-DD');
            this.form.date_time_to = this.$moment(this.dateInterval[1]).format('YYYY-MM-DD');
        },
        isEditTargetingDisabled() {
            return this.selected.usersCount < targetingMinimalUsersCount;
        },
        getTypeName(typeId) {
            switch (typeId) {
                case 1:
                    return 'clicks';
                case 2:
                    return 'actions';
                default:
                    return '';
            }
        },
        getGoalName(goalIds) {
            if (!goalIds) {
                return '';
            }

            let goalNames = [];
            goalIds.forEach(g => {
                const goal = this.dicts.goals.find(i => i.id == g);
                if (goal) {
                    goalNames.push(goal.name);
                }
            });

            return goalNames.join(',\n');
        }
    },
    mounted() {
        this.setDefaultValues();
        this.loadDicts();
        this.loadAuditories(true);
    },
    watch: {
        page: function () {
            this.loadAuditories();
        },
        dateInterval: function (newTime) {
            this.form.date_time_from = this.$moment(newTime[0]).format('YYYY-MM-DD HH:mm:ss');
            this.form.date_time_to = this.$moment(newTime[1]).format('YYYY-MM-DD HH:mm:ss');
        }
    },
    beforeCreate() {
        // Установка заголовка вкладки
        document.title = 'Аудитории ремаркетинга';
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}
thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}
.header-title {
    flex-direction: column;
}

.mx-input {
    height: 38px;    
}

.vs-pagination-primary {
    margin-top: 10px;
}

.auditory-create .sweet-modal,
.auditory-edit .sweet-modal{
    overflow-y: visible !important;
}

.events-select .vs__dropdown-menu {
    overflow-y: scroll !important;
    z-index: 1 !important;
}
</style>
